import { AppForm } from '../../../../../../../common/forms/app.form';
import { Injectable } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';

@Injectable()
export class RemovalOfTreesOrShrubsStatementsForm extends AppForm {

  public propertyUsagePurposeList: string[] = [
    'Właściciel',
    'Współwłaściciel',
    'Najemca',
    'Dzierżawca nieruchomości',
    'Korzystam z nieruchomości w ramach służebności'
  ];

  constructor() {
    super({
      testimonyStatement: new FormControl(false, {
        nonNullable: true,
        validators: [Validators.required, Validators.requiredTrue]
      }),
      propertyOwnerStatement: new FormControl(false, {
        nonNullable: true,
        validators: [Validators.required, Validators.requiredTrue]
      }),
      propertyUsagePurpose: new FormControl('', {
        nonNullable: true,
        validators: [Validators.required, Validators.maxLength(255)]
      }),
      removalForBusinessPurpose: new FormControl(null, Validators.required)
    });
  }

  public get propertyUsagePurpose(): FormControl {
    return this.get('propertyUsagePurpose') as FormControl;
  }

  public get allIsTouched(): boolean {
    const keys = Object.keys(this.controls);
    let count = 0;
    keys.forEach(key => {
      if (this.get(key)?.touched) {
        count++;
      }
    });
    return count === keys.length;
  }
}
